var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.points)?_c('div',{staticClass:"leaderboard-table__progress",style:({
    minWidth: _vm.caclWidthPersents(_vm.points, _vm.divider) + '%',
    backgroundColor: _vm.randomColor()
  })},[_vm._v("\n  "+_vm._s(Math.round(_vm.points.replace(",", "")))+"\n")]):_c('div',{staticClass:"leaderboard-table__cell leaderboard-table__progress",staticStyle:{"width":"0","background-color":"transparent","color":"inherit"}},[_vm._v("\n  0\n")])}
var staticRenderFns = []

export { render, staticRenderFns }